app.service("PreOp", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		// var service = {
		// 	isProcessing: false,
		// 	conatctMessage: '',
		// 	feedbackMessage: '',
		// 	contact: function(message) {
		// 		return $http({
		// 			method: 'POST',
		// 			url: ENV.API + '/api/emails/contact',
		// 			headers: {
		// 				'Authorization': 'Bearer ' + Session.token,
		// 			},
		// 			data: {
		// 				"sender": {
		// 					"id": Session.userId
		// 				},
		// 				"message": message
		// 			}
		// 		})
		// 	},
		// 	feedback: function(message, subject) {
		// 		return $http({
		// 			method: 'POST',
		// 			url: ENV.API + '/api/emails/feedback',
		// 			headers: {
		// 				'Authorization': 'Bearer ' + Session.token,
		// 			},
		// 			data: {
		// 				"sender": {
		// 					"id": Session.userId
		// 				},
		// 				"message": message,
		// 				"subject": subject
		// 			}
		// 		})
		// 	},
		// };
		var service = {
			isProcessing: false,
			setData: function (data) {
				service.data = data;
			},
			data: {},
			// The scanner the current biometry was loaded from (BiometryType), and that scan's own
			// per-eye records, when the workup was loaded from one rather than typed in. Both are kept
			// outside `data` so they are never part of a saved workup: the scan holds measurements
			// (CCT, lens thickness, WTW) that SurgicalPlanBiometry cannot store but the IOL calculator
			// hand-off wants. Cleared per patient in preOpController.
			biometryDevice: null,
			biometryImport: null,
		};

		return service;
	},
]);
